import React, { useState, useEffect } from "react";
import Translator, { __ } from "services/Translator";
import { Dropdown } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import api from "services/api";

export default function LanguageSwitcherAccordion(props) {
  const history = useHistory();
  const [languages, setLanguages] = useState([]);
  const selectedLanguage = Translator.getSelectedLanguage();
  const getLanguages = async () => {
    var response = await api.get("/languages");
    if (response.status === 200) {
      // setLanguages(
      //   response.data.map((val) => {
      //     return { label: val.language, value: val.code };
      //   })
      // );
      setLanguages(response.data);
    } else {
      props.showAlert("Warning!!", response.data.message);
    }
  };

  const switchLanguage = (lang) => {
    // var homeUrl = history.createHref({ pathname: "/" });
    // var currentUrl = window.location.href;
    // var newUrl = currentUrl.replace(homeUrl, "/" + lang.code + "/");
    Translator.setSelectedLanguage(lang);
    // window.location.href = newUrl;
    window.location.reload();
  };

  useEffect(() => {
    getLanguages();
  }, []);

  return (
    <div className="languageSwitcherAccordion">
      <div className="accordion accordion-flush" id="accordionFlushExample">
        <div className="accordion-item">
          <h2
            className="accordion-header accordionBtnStyle"
            id="flush-headingOne"
          >
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseOne"
              aria-expanded="false"
              aria-controls="flush-collapseOne"
            >
              <div className="icon">
                <img
                  alt=""
                  style={{ width: "25px" }}
                  src={
                    require("../assets/images/icons/left_sidebar/language-icon.svg")
                      .default
                  }
                />
              </div>
              <div className="text">
                {__("Language:")} {selectedLanguage.language}
              </div>
            </button>
          </h2>
          <div
            id="flush-collapseOne"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <ul className="languageItemLists">
              {languages.length > 0 &&
                languages.map((value, index) => (
                  <li
                    onClick={() => switchLanguage(value)}
                    className={
                      selectedLanguage.code == value.code ? "selected" : ""
                    }
                  >
                    <label for={value.code} className="text fullName">
                      {value.alias ? value.alias : value.language}
                    </label>

                    <label for={value.code} className="text shortName">
                      {value.code}
                    </label>
                    <input
                      type="radio"
                      id={value.code}
                      defaultChecked={
                        selectedLanguage.code == value.code ? true : false
                      }
                      name="lang"
                    />
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
